/**
 * DistributionTab
 *
 * Buffer-powered multi-platform scheduling (Twitter, LinkedIn, etc.) was
 * removed 2026-02. Pinterest scheduling now lives in the Images tab and
 * uses Metricool. This component is kept as a thin notice so the existing
 * tab in ContentPackageEditor doesn't break.
 */
import { Link } from "react-router-dom";
import { ExternalLink, Send } from "lucide-react";

export default function DistributionTab() {
    return (
        <div
            className="bl-card p-5 max-w-2xl space-y-3"
            data-testid="distribution-tab-deprecated"
        >
            <div className="flex items-center gap-2 text-bl-primary">
                <Send className="h-5 w-5" />
                <h3 className="font-display font-semibold text-lg">
                    Distribution moved
                </h3>
            </div>
            <p className="text-sm text-bl-muted">
                Multi-platform scheduling via Buffer was removed in favor of
                <strong className="text-bl"> Metricool </strong>
                for Pinterest. Pinterest pins now ship directly from the
                <strong className="text-bl"> Images </strong> tab.
            </p>
            <p className="text-sm text-bl-muted">
                Configure Metricool credentials, brand selection, and the
                board mappings on the Metricool settings page.
            </p>
            <div>
                <Link
                    to="/admin/metricool"
                    className="bl-btn-primary text-xs gap-1.5 inline-flex"
                    data-testid="distribution-go-to-metricool"
                >
                    <ExternalLink className="h-3 w-3" /> Open Metricool Settings
                </Link>
            </div>
        </div>
    );
}
